module.exports = __webpack_public_path__ + "static/media/Help.3be28d8d.svg";